// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"fa676915","1279":"7b99a812","5700":"fa676915","6674":"9a655a13","7873":"dd7072ef","8793":"a51722d9"}[chunkId] + ".chunk.css";
};